export default {"src":"/_next/static/media/user-blue.8049461f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};